import { RisksType, getRiskMitigationStrategyStatus, RISK_STATUS } from 'domain/shared/newProject';

type RisksInitialDataShape = {
  risks?: RisksType[];
};

export const getRisksInitialData = <T extends object>(data?: T) => {
  const dataWithRisks = data as (T & RisksInitialDataShape) | undefined;

  return {
    ...data,
    risks:
      dataWithRisks?.risks?.map(risk => ({
        ...risk,
        mitigationStrategyStatus: getRiskMitigationStrategyStatus(risk.mitigationStrategy),
        _effectiveUpdatedAt: risk.status === RISK_STATUS.INACTIVE ? '' : risk.updatedAt || risk.createdAt,
      })) || [],
  } as T & { risks: RisksType[] };
};
